export default __webpack_public_path__ + "static/step1-f71dc73c0f74ed2b23803285301bb392.jpg";